<template>
  <div class="setting-body">
    <div class="setting-body-title m-b-20">{{ routerTitle }}</div>
    <div class="basic-setting">
      <el-form>
        <!--        上传头像-->
        <el-form-item label="头像" />
        <preview-image
          v-if="readOnly"
          :file-id="formData.face"
          around
          class="m-b-20"
        />
        <upload
          v-else
          :props-data="{
            attachmentType: 'face',
            bizType: 'user_center',
            uploadMode: 'fileId',
            fileIdBefore: formData.face,
            photoWall: true,
            photoWallStyle: {
              around: true,
              needPreview: false
            },
            fileSize: 2,
            onSuccess: uploadSuccess
          }"
          class="m-b-20"
        >
          <div slot="tip" class="tip-mes">
            <p>图片格式支持JPG，JPEG，PNG格式</p>
            <p>支持2M以内的图片</p>
          </div>
        </upload>
      </el-form>

      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        hide-required-asterisk
      >
        <!--        昵称-->
        <el-form-item prop="nickname" label="用户昵称">
          <el-input
            v-model.trim="formData.nickname"
            size="medium"
            maxlength="10"
            :disabled="readOnly"
            placeholder="请输入用户昵称"
          />
        </el-form-item>

        <!--        昵称-->
        <el-form-item prop="email" label="用户邮箱">
          <el-input
            v-model.trim="formData.email"
            size="medium"
            maxlength="150"
            :disabled="readOnly"
            placeholder="请输入用户邮箱"
          />
        </el-form-item>
        <div class="basic-setting-footer flex-center">
          <el-button
            v-if="readOnly"
            class="default"
            size="small"
            @click="readOnly = false"
          >修改</el-button>
          <template v-else>
            <el-button
              size="small"
              class="default"
              @click="cancel"
            >取消</el-button>
            <el-button
              type="primary"
              class="default"
              size="small"
              @click="editUserInfo"
            >保存</el-button>
          </template>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PreviewImage from '@/components/Upload/PreviewImage'
import Upload from '@/components/Upload'
// 引入api接口
import { editUserInfoApi } from '@/api/user'
import personalMixin from '@/views/personal-center/personalMixin'

export default {
  name: 'BasicSetting',

  components: { Upload, PreviewImage },

  mixins: [personalMixin],

  data() {
    return {
      readOnly: true,
      formData: {
        nickname: '',
        email: '',
        face: ''
      },
      rules: {
        nickname: [
          {
            required: true,
            message: '昵称不能为空',
            trigger: ['blur', 'change']
          },
          {
            max: 10,
            message: '昵称最长不能超过10个字符',
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '用户邮箱不能为空',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
            message: '请输入正确的电子邮箱格式',
            trigger: 'blur'
          },
          {
            max: 150,
            message: '邮箱最长不能超过150个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  computed: {
    ...mapState('user', ['nickname', 'face', 'userEmail'])
  },

  watch: {
    nickname: {
      handler: function(val) {
        this.formData.nickname = val
      },
      immediate: true
    },
    face: {
      handler: function(val) {
        this.formData.face = val
      },
      immediate: true
    },
    userEmail: {
      handler: function(val) {
        this.formData.email = val
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions('user', ['getUserInfo']),

    // 上传头像前的钩子函数
    beforeUpload(file) {
      const isImg =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 <= 2

      if (!isImg) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isImg && isLt2M
    },

    // 上传头像的成功回调
    uploadSuccess(groupId) {
      this.formData.face = groupId
    },

    // 提交修改的用户信息
    editUserInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.$message.error('信息填写错误，请按照提示正确填写信息')
          return
        }

        editUserInfoApi(this.formData)
          .then(res => {
            this.$message.success('信息修改成功')
            this.getUserInfo()
            this.readOnly = true
          })
          .catch(err => {
            this.readOnly = false
            this.$message.error(err.data?.message || '信息修改失败，请稍后重试')
          })
      })
    },

    // 取消
    cancel() {
      this.readOnly = true
      this.formData = {
        nickname: this.nickname,
        face: this.face,
        email: this.userEmail
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.setting-body {
  width: 1030px;
  padding: 20px;
  background-color: $white-color;
  overflow: hidden;
  position: relative;
  border-radius: 4px;

  .setting-body-title {
    text-align: left;
    font-size: 20px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 25px;
      background-color: $primary-color;
      vertical-align: bottom;
      margin-right: 10px;
    }
  }
}

.basic-setting {
  display: flex;
  padding: 0 60px;
  box-sizing: border-box;

  ::v-deep .el-form {
    width: 50%;
    text-align: left;
  }

  .tip-mes {
    display: inline-block;
    color: $text-third-color;
    font-size: 14px !important;
    vertical-align: middle;

    p {
      margin: 0;
    }
  }

  .basic-setting-footer {
    margin-top: 30px;
    //::v-deep .el-button {
    //  height: pixel-to-rem($n: 40);
    //  padding-top: 0;
    //  padding-bottom: 0;
    //}
  }

  .basic-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .info-item {
      width: 300px;
      text-align: left;
      font-size: 16px;
      display: flex;
      align-items: flex-start;
      margin-top: 20px;

      .info-item--label {
        white-space: nowrap;
        vertical-align: top;
      }
    }
  }
}
</style>
